import '@wordpress/element';
import Splide from '@splidejs/splide';

document.addEventListener('DOMContentLoaded', function() {
	
	const containers = document.querySelectorAll('.carousel-container');
	
	document.querySelectorAll('.carousel-container').forEach(container => {
		// Debug the slides
		const slides = container.querySelectorAll('.wp-block-cover');
		const slidesToShow = container.dataset.slidesToShow;
		const gap = parseInt(container.dataset.gap) || 0;
		const activeColor = container.dataset.activeColor || '#000000';
		const inactiveColor = container.dataset.inactiveColor || 'rgba(0, 0, 0, 0.5)';
		const loop = container.dataset.loop === 'true';
		const arrowsActive = container.dataset.arrowsActive === 'true';
		const arrowsOnHover = container.dataset.arrowsOnHover === 'true';
		const paginationActive = container.dataset.paginationActive === 'true';
		const transition = container.dataset.transition;
		const focus = container.dataset.focus;
		const autoSlide = container.dataset.autoSlide === 'yes';
		const autoSlideInterval = container.dataset.autoSlideInterval ? parseInt(container.dataset.autoSlideInterval) : 5000;
		
		container.style.setProperty('--carousel-active-color', activeColor);
		container.style.setProperty('--carousel-inactive-color', inactiveColor);

		// Add splide__slide class to each cover block
		slides.forEach(slide => {
			const slideWrapper = document.createElement('li');
			slideWrapper.className = 'splide__slide';
			slide.parentNode.insertBefore(slideWrapper, slide);
			slideWrapper.appendChild(slide);
		});

		// Initialize Splide
		const splide = new Splide(container, {
			type: transition,
			perPage: slidesToShow,
			gap: gap,
			arrows: (arrowsActive && !arrowsOnHover) ? true : false,
			pagination: paginationActive ? true : false,
			rewind: true,
			interval: autoSlide == true ? autoSlideInterval : false,
			autoplay: autoSlide,
			transition: transition,
			autoHeight: true,
      		focus: focus,
			perMove: 1,
			lazyLoad: 'nearby',
			breakpoints: {
				768: {
					perPage: 1,
				},
			},
			updateOnMove: true,
			speed: 400,
			easing: 'cubic-bezier(0.25, 1, 0.5, 1)'
		}).mount();

		if (arrowsOnHover) {
			// Create floating arrows
			const floatingArrow = document.createElement('div');
			floatingArrow.className = 'floating-arrow';
			floatingArrow.innerHTML = `
				<div class="arrow-circle">
					<svg class="arrow-left" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor">
						<path stroke-linecap="round" stroke-linejoin="round" d="M10.5 19.5 3 12m0 0 7.5-7.5M3 12h18" />
					</svg>
					<svg class="arrow-right" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor">
						<path stroke-linecap="round" stroke-linejoin="round" d="M13.5 4.5 21 12m0 0-7.5 7.5M21 12H3" />
					</svg>
				</div>
			`;
			container.appendChild(floatingArrow);

			let mouseTimeout;
			let isRightSide = false;
			let arrowsEnabled = true;

			const track = container.querySelector('.splide__track');

			// Disengage floating arrows when hovering a link
			track.addEventListener('mouseover', (e) => {
				if (e.target.closest('a')) {
					arrowsEnabled = false;
					floatingArrow.style.opacity = '0';
				}
			});
			track.addEventListener('mouseout', (e) => {
				if (e.target.closest('a')) {
					arrowsEnabled = true;
				}
			});

			// Handle mouse movement
			track.addEventListener('mousemove', (e) => {
				if (!arrowsEnabled) return;
				const rect = track.getBoundingClientRect();
				const x = e.clientX - rect.left;
				const y = e.clientY - rect.top;
				isRightSide = x > rect.width / 2;

				floatingArrow.style.opacity = '1';
				floatingArrow.style.left = `${x}px`;
				floatingArrow.style.top = `${y}px`;
				floatingArrow.classList.toggle('right-side', isRightSide);
				floatingArrow.classList.toggle('left-side', !isRightSide);

				clearTimeout(mouseTimeout);
				mouseTimeout = setTimeout(() => {
					floatingArrow.style.opacity = '0';
				}, 2000);
			});

			// Handle click
			track.addEventListener('click', (e) => {
				if (!arrowsEnabled) return;
				if (isRightSide) {
					splide.go('+1');
				} else {
					splide.go('-1');
				}
			});

			track.addEventListener('mouseleave', () => {
				floatingArrow.style.opacity = '0';
			});
		}
	});
}); 